export default function IconCommonFileDouble({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 25.7143 25.7143"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M18.3061 0.536133C18.5903 0.536193 18.8628 0.649116 19.0636 0.850061L22.7215 4.50792C22.9225 4.7088 23.0354 4.98128 23.0354 5.26542V20.8933C23.0354 21.1774 22.9226 21.45 22.7216 21.6509C22.5207 21.8518 22.2482 21.9647 21.964 21.9647H6.96401C6.67985 21.9647 6.40732 21.8518 6.20639 21.6509C6.00546 21.45 5.89258 21.1774 5.89258 20.8933V1.60756C5.89258 1.3234 6.00546 1.05088 6.20639 0.849947C6.40732 0.649015 6.67985 0.536133 6.96401 0.536133H18.3061Z"
        stroke="#4D4D4D"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8206 21.9643V24.1071C19.8206 24.3913 19.7077 24.6638 19.5068 24.8648C19.3058 25.0657 19.0333 25.1786 18.7492 25.1786H3.74916C3.465 25.1786 3.19248 25.0657 2.99155 24.8648C2.79062 24.6638 2.67773 24.3913 2.67773 24.1071V4.82143C2.67773 4.53727 2.79062 4.26475 2.99155 4.06381C3.19248 3.86288 3.465 3.75 3.74916 3.75H5.89202"
        stroke="#4D4D4D"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
